/**
 * Whether a file/image value carries a download the renderers may offer.
 *
 * A download exists only when the server presigned one — `link` on the
 * value, put there by FileLinks::hydrate() on a passport read or by
 * DataRequestService::represent() on a request page. A Drive reference read
 * without that (a stored value the page did not link, a submitted answer
 * whose file is gone) has no `link`, and an anchor without an href is a
 * "Download" that goes nowhere — and, being inline, sat on top of the
 * filename in a narrow card. Name and size still say what the file is.
 */
export const hasDownloadLink = (value) => typeof value?.link === 'string' && value.link !== '';
